import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputNumber } from "primereact/inputnumber";
import { Panel } from "primereact/panel";
import { useReactToPrint } from "react-to-print";
import { useState, useEffect, useRef } from "react";

export function RelacaoTecido({ data, values }) {
  const [artigos, setArtigos] = useState([]);
  const [producao, setProducao] = useState(data);
  const [segundos, setSegundos] = useState(1);
  const [date, setDate] = useState(new Date());
  const [metros, setMetros] = useState(0);
  const [urdume, setUrdume] = useState(0);

  const [engomagem, setEngomagem] = useState([]);

  const [printing, setPrinting] = useState(false);

  const component = useRef();

  function format(rowData, props) {
    return Intl.NumberFormat("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(rowData[props.field]);
  }

  function todayDate() {
    let date = new Date();
    let day = String(date.getDate()).padStart(2, 0);
    let month = String(date.getMonth() + 1).padStart(2, 0);
    let year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  const handlePrint = useReactToPrint({
    content: () => component.current,
    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setPrinting(true);
        setTimeout(() => {
          resolve();
        }, 500);
      });
    },
    onAfterPrint: () => {
      setPrinting(false);
    },
  });

  useEffect(() => {
    let fios = [];

    data.forEach((item) => {
      if (fios.indexOf(item.titulo) === -1) {
        fios.push(item.titulo);
      }
    });

    let array = [];
    fios.forEach((item) => {
      let object = {};
      object.fio = item;

      let filtered = data.filter((element) => {
        return element.titulo === item;
      });

      filtered.forEach((data) => {
        if (object[data.dataf] === undefined) {
          object[data.dataf] = 1;
        } else {
          object[data.dataf] += 1;
        }
      });

      array.push(object);
    });

    setEngomagem(array);
  }, [data]);

  useEffect(() => {
    let dados = [...data];

    setTimeout(() => {
      let now = new Date();
      dados.forEach((item) => {
        let initial = new Date(item.data_inicial.replace("-", "/"));
        let segundos_agora = (now - initial) / 1000;
        let previsto = (date - initial) / 1000;

        let maximo = parseFloat(item.metros_tecido) + parseFloat(item.metros);
        let valor_previsto =
          parseFloat(item.metros_tecido) +
          previsto * parseFloat(item.producao_segundo);
        valor_previsto *= 0.85;

        if (valor_previsto >= maximo) valor_previsto = maximo;

        if (item.produzindo >= maximo) {
          item.produzindo = maximo;
          item.urdume = 0;
          item.previsto = maximo * 0.85;
        } else {
          item.produzindo =
            parseFloat(item.metros_tecido) +
            segundos_agora * parseFloat(item.producao_segundo);
          item.urdume =
            parseFloat(item.metros) -
            segundos_agora * parseFloat(item.producao_segundo);
        }

        item.previsto = valor_previsto;
      });

      dados = dados.filter((element) => {
        return element.produzindo > metros && element.urdume > urdume;
      });

      setSegundos((segundos) => segundos + 1);
      setProducao(dados);
    }, [1000 * 1]);
  }, [segundos, metros, urdume, data, date]);

  return (
    <div>
      <h2>Relação de Fios - Engomagem</h2>
      <Panel header="Relação - Engomagem" toggleable collapsed>
        <DataTable
          className="p-m-1"
          emptyMessage="Nenhum registro encontrado."
          size="small"
          value={engomagem}
        >
          <Column
            header="Fio"
            alignHeader="center"
            field="fio"
            style={{ fontSize: 20, borderWidth: 1, borderColor: "#000" }}
          />
          {values.datas.map((item, index) => {
            return (
              <Column
                key={"fio" + index}
                header={item}
                alignHeader="center"
                field={item}
                headerStyle={{ fontSize: 24 }}
                style={{
                  borderColor: "#000",
                  borderWidth: 1,
                  margin: 0,
                  padding: 0,
                }}
                body={(rowData) => (
                  <h3 className="p-m-1" style={{ textAlign: "center" }}>
                    {rowData[item]}
                  </h3>
                )}
              />
            );
          })}
        </DataTable>
      </Panel>

      <Panel header="Produção - Atual" toggleable collapsed>
        <h2>Relação de Produção de Tecido - {todayDate()}</h2>
        <Calendar
          className="p-m-1"
          dateFormat="dd/mm/yy"
          mask="99/99/9999"
          onChange={(e) => {
            if (e.value.getTime() >= new Date().getTime()) {
              setDate(e.value);
            } else {
              e.preventDefault();
            }
          }}
          value={date}
        />

        <Button className="p-m-1" icon="pi pi-search" />
        <Button className="p-m-1" icon="pi pi-print" onClick={handlePrint} />
        <div className="p-fluid p-formgrid p-grid">
          <div className="p-field p-col">
            <label htmlFor="metragem">Acima de (m)</label>
            <InputNumber
              className="p-m-1"
              onChange={(e) => setMetros(e.value)}
              placeholder="Digite a metragem"
              value={metros}
            />
          </div>
          <div className="p-field p-col">
            <label htmlFor="">Acima de (urdume)</label>
            <InputNumber
              className="p-m-1"
              onChange={(e) => setUrdume(e.value)}
              placeholder="Digite o urdume"
              value={urdume}
            />
          </div>
        </div>
        <DataTable
          className="p-m-1"
          emptyMessage="Nenhum tear produzindo..."
          filterDisplay={printing ? "" : "row"}
          header={() => {
            let total = 0;
            artigos.forEach((element) => {
              total += parseFloat(element.previsto);
            });
            return (
              <div>
                <h3 className="p-m-1">
                  Previsto:{" "}
                  {Intl.NumberFormat("pt-BR", {
                    maximumFractionDigits: 0,
                  }).format(total)}
                  m
                </h3>
              </div>
            );
          }}
          onValueChange={(data) => {
            setArtigos(data);
          }}
          ref={component}
          value={producao}
          style={{ fontSize: printing === true ? 14 : 20 }}
          size={printing === true ? "small" : "normal"}
        >
          <Column
            header="Tear"
            filter={!printing}
            showFilterMenu={false}
            field="tear"
            sortable
            style={{ width: "25%" }}
          />
          <Column
            header="Artigo"
            filter={!printing}
            showFilterMenu={false}
            field="artigo"
            sortable
            style={{ width: "25%" }}
          />
          <Column
            header="Produção Atual (m)"
            field="produzindo"
            sortable
            body={format}
          />
          <Column
            header="Urdume Restante (m)"
            field="urdume"
            sortable
            body={format}
          />
          <Column
            header="Previsto (m)"
            field="previsto"
            sortable
            body={format}
          />
        </DataTable>
      </Panel>
    </div>
  );
}
